/**
 * remark-plot-fence — tags ```plot code nodes with data-plot-* for PlotEmbed.
 */

import type { Plugin } from 'unified';
import type { Root, Code } from 'mdast';
import { visit } from 'unist-util-visit';
import { parsePlotFenceBody } from '../plots/plot-spec.js';

export const remarkPlotFence: Plugin<[], Root> = () => {
  return (tree) => {
    visit(tree, 'code', (node: Code) => {
      if (node.lang !== 'plot') return;
      const result = parsePlotFenceBody(node.value ?? '');
      const data = (node.data ??= {});
      if (!result.ok) {
        data.hProperties = {
          'data-plot': 'error',
          'data-plot-error': result.error,
        };
        return;
      }
      data.hProperties = {
        'data-plot': '1',
      };
    });
  };
};
